import React from 'react';
import { Skeleton } from 'primereact/skeleton';

import './MetricCard.scss';

export interface MetricCardProps {
  /** Prominent value, e.g. "0.96", "21.3 : 1", "48.9%". */
  value: string;
  /** Label under the value, e.g. "GENDER PARITY INDEX". */
  label: string;
  /** Accent color for the value text. Defaults to the brand color. */
  accent?: string;
  /** Optional PrimeIcons class shown top-right. */
  icon?: string;
  /** Show a loader in place of the value while data is being fetched. */
  loading?: boolean;
  /** Extra class names. */
  className?: string;
}

/**
 * A reusable secondary-metric card (white card with a colored value and a
 * muted uppercase label).
 *
 * @example
 * <MetricCard value="0.96" label="Gender Parity Index" accent="#22c55e" />
 */
const MetricCard: React.FC<MetricCardProps> = ({
  value,
  label,
  accent = '#313fc4',
  icon,
  loading = false,
  className = '',
}) => {
  return (
    <div className={`metric-card ${className}`.trim()}>
      {icon && (
        <span className="metric-card__icon">
          <i className={icon} />
        </span>
      )}
      {loading ? (
        <Skeleton width="70%" height="1.6rem" className="mb-1" />
      ) : (
        <span className="metric-card__value">{value}</span>
      )}
      <span className="metric-card__label">{label}</span>
    </div>
  );
};

export default MetricCard;
